import { FC } from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'

import { Main } from '../pages'
import { theme } from '../theme'

export const App: FC = () => {
  return (
    <ChakraProvider resetCSS theme={theme}>
      <Router>
        <Switch>
          <Route exact path="/" component={Main} />
          <Redirect to="/" />
        </Switch>
      </Router>
    </ChakraProvider>
  )
}
